export const BOOK_URL = "https://www.tpeco.com.au/#book";
export const PHONE_DISPLAY = "(08) 9477 3848";
export const PHONE_TEL = "tel:+61894773848";
export const EMAIL = "team@tpeco.com.au";

export const IMG = {
  logo: "/logo.webp",
  heroPipes:
    "https://images.unsplash.com/photo-1647105604066-86ea4247e217?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwcGlwZXMlMjBkYXJrfGVufDB8fHx8MTc4NjAwMTI0MXww&ixlib=rb-4.1.0&q=85",
  jetter: "/jetter.png",
  technician: "/process.webp",
  splash: "https://images.unsplash.com/photo-1594372365401-3b5ff14eaaed?q=85&w=900",
  fiveStarBadge:
    "https://images.squarespace-cdn.com/content/v1/6965e36e5a06e032300a47b8/885d598a-8bed-4334-91e0-670233f16675/100%2B+5+Star+Reviews.png",
  yellowBadge:
    "https://images.squarespace-cdn.com/content/v1/6965e36e5a06e032300a47b8/60709dfc-715c-4f20-b19c-8f61f116843f/2026+Yellow+Badge+-+The+Plumbing+%26+Electrical+Co...png",
};
